<template>
  <!-- <Mobile v-if="isMobileUa" :list="list" :skuType="props.skuType" :isPersonal="props.isPersonal" /> -->
  <div :class="$style.Container">
    <template v-if="!props.loading">
      <div :class="$style.Header">
        <img
          style="width: 31px; height: 19.7px; margin-left: 16px"
          src="https://static.lingvisions.com/public/a8d66af63e954f4a9185920943edd75a.svg"
        />
        <a :class="$style.Question" target="_blank" href="https://www.lingvisions.com/cases/20"
          >常见问题</a
        >
      </div>
      <div :class="$style.Title">{{ list[props.skuType].title }}</div>
      <!-- <img :class="$style.Title" :src="list[props.skuType].titleImaUrl" />-->
      <div
        :class="$style.Item"
        :style="{
          borderRadius: list[props.skuType].texts.length === 1 ? '20px' : undefined,
        }"
      >
        <div v-for="item in list[props.skuType].texts" :key="item.title">
          <img
            src="https://static.lingvisions.com/public/ee267cdfe99347c186651eb9230f90d2.svg"
            style="width: 16px; height: 16px; margin-right: 4px"
          />

          <div :class="$style.ItemText">{{ item.title }}</div>
        </div>
      </div>

      <div :class="$style.Info">
        <div
          v-for="(item, index) in list[props.skuType].infos"
          :key="index"
          :class="animated ? undefined : $style.InfoItemAnimation"
          :style="
            animated
              ? undefined
              : {
                  animationDelay: `${index * 200}ms`,
                }
          "
        >
          <img
            style="width: 16px; height: 16px; margin-right: 4px"
            src="https://static.lingvisions.com/public/497d18b491de4e5b9e62aac94da233f0.svg"
          />
          <div :class="$style.Tip">{{ item.title }}</div>
        </div>
      </div>
      <!-- <div :class="$style.Footer">
        
      </div> -->
    </template>
  </div>
</template>

<script lang="ts" setup>
  import { computed, onMounted, ref, watch } from 'vue';
  import { CheckOutlined } from '@ant-design/icons-vue';
  import { SKU_TYPE } from '../../constants';
  import { getIsMobileUa } from '../../utils/ua';
  import Mobile from './mobile.vue';

  const isMobileUa = getIsMobileUa();
  const PERSONAL_TIPS =
    'https://static.lingvisions.com/public/3210b888c6514a9ca54133f81570f693.png';
  const ORG_TIPS =
    'https://static.lingvisions.com/public/4c4fb4b749e04ab480b4100c6e1abac4.png';
  interface Props {
    skuType: SKU_TYPE;
    isPersonal: boolean;
    loading?: boolean;
    seat?: string;
    price?: string | number;
    amount?: string | number;
    expiresIn?: string;
    seatNum?: string;
  }

  const list = computed(() =>
    // 个人会员文案
    props.isPersonal
      ? {
          [SKU_TYPE.VIP]: {
            title: '个人会员专属',
            texts: [
              {
                title: `每月获得${props.amount}灵豆`,
              },
              {
                title: '畅想无限生成',
              },
            ],
            infos: [
              {
                title: '灵图站内全部AI功能',
              },
              {
                title: '无水印导出',
              },
              {
                title: '高清下载',
              },
            ],
          },
          [SKU_TYPE.PURCHASE]: {
            title: '灵豆',
            texts: [
              {
                title: `${+props.amount!}灵豆，每灵豆仅 ${(+props.price / +props.amount!).toFixed(
                  2,
                )}元`,
              },
            ],
            infos: [
              {
                title: `${props.expiresIn}天有效期`,
              },
              {
                title: '灵图站内全部AI功能',
              },
              {
                title: '无水印导出',
              },
              {
                title: '高清下载',
              },
            ],
          },
        }
      : // 团队会员文案
        {
          [SKU_TYPE.VIP]: {
            title: '团队会员专属',
            texts: [
              props.seatNum
                ? {
                    title: `每月获得${props.amount}灵豆`,
                  }
                : undefined,
              {
                title: `畅想无限生成`,
              },
            ].filter((v) => v),
            infos: [
              {
                title: '灵图站内全部AI功能',
              },
              {
                title: props.seatNum
                  ? `团队成员共享会员权益，上限${props.seatNum}人`
                  : '团队成员共享会员权益',
              },
              {
                title: '无水印导出',
              },
              {
                title: '高清下载',
              },
            ],
          },
          [SKU_TYPE.PURCHASE]: {
            title: '灵豆',
            texts: [
              {
                title: `${+props.amount!}灵豆，每灵豆仅 ${(+props.price / +props.amount!).toFixed(
                  2,
                )}元`,
              },
            ],
            infos: [
              {
                title: `${props.expiresIn}天有效期`,
              },
              {
                title: '灵图站内全部AI功能',
              },
              {
                title: '无水印导出',
              },
              {
                title: '高清下载',
              },
            ],
          },
        },
  );

  const props = defineProps<Props>();
  const animated = ref(false);

  watch(
    () => props.loading,
    (v) => {
      if (v) {
        setTimeout(() => {
          animated.value = true;
        }, 2000);
      }
    },
    {
      immediate: true,
    },
  );
</script>

<style lang="less" module>
  .Container {
    width: 312px;
    position: relative;
    padding: 24px 16px 0;
    background: url(https://static.lingvisions.com/public/7e6854878adc4c75b0b00694eb567016.png)
      center/cover no-repeat #225849;
    border-radius: 16px 0 0 16px;
  }

  .Title {
    margin-top: 64px;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0%;
    color: rgba(255, 255, 255, 1);
    margin-left: 16px;
  }

  .Header {
    height: 22px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .Item {
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 0.1);
    margin-top: 34px;
    padding: 8px 0 8px 16px;
    color: rgba(255, 255, 255, 1);

    > div {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .ItemText {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  .Info {
    margin-top: 16px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);

    > div {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      margin-left: 16px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .InfoItemAnimation {
    animation: fade-in 0.5s ease forwards;
    opacity: 0;
    transform: translateX(-10px);
  }

  .Footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: absolute;
    bottom: 32px;
    left: 0;
  }

  .Question {
    font-weight: 500;
    font-size: 12px;
    line-height: 1;
    letter-spacing: 0%;
    cursor: pointer;
    color: rgba(255, 255, 255, 1) !important;

    &:hover {
      color: #d16c44 !important;
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateX(-10px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
</style>
